module.exports = __webpack_public_path__ + "img/bibang.a0babc07.png";